import * as React from 'react';
import {
  IconSocialVKFilled16,
  IconSocialYoutube16,
  IconSocialTelegramFilled16,
  IconSocialInstagramFilled16,
  IconInfrastructureInternet16,
} from '@cian/ui-kit-design-tokens/icons';

import { ESocialType } from '../../types/builder';

interface ISocialIconProps {
  type: ESocialType;
}

export const SocialIcon: React.FC<ISocialIconProps> = ({ type }) => {
  const color = 'accent-main-primary';

  switch (type) {
    case ESocialType.Instagram:
      return <IconSocialInstagramFilled16 color={color} />;
    case ESocialType.Telegram:
      return <IconSocialTelegramFilled16 color={color} />;
    case ESocialType.Vk:
      return <IconSocialVKFilled16 color={color} />;
    case ESocialType.Youtube:
      return <IconSocialYoutube16 color={color} />;
    default:
      return <IconInfrastructureInternet16 color={color} />;
  }
};
